







































































































import Vue from '@front-app/vendor/vue';
import {
	computed,
	defineComponent,
	nextTick,
	PropType,
	ref,
} from '@vue/composition-api';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import ChevronIcon from '@front-app/components/icons-old/ChevronDown.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import { SelectBoxChoice } from './SelectBoxModel';

let i = 0;
const uid = () => `select_box_${i++}`;

export default defineComponent({
	components: {
		SimpleDropdown,
		FormInput,
		ChevronIcon,
		TrCheckbox,
		CtaButton,
	},
	props: {
		choices: {
			type: Array as PropType<SelectBoxChoice[]>,
			required: true,
		},
		selectedChoices: {
			type: Array as PropType<(string | number)[]>,
			default: () => [],
		},
		position: {
			type: Number as PropType<DropdownPosition>,
			default: DropdownPosition.BOTTOM_RIGHT,
		},
		focusItemKey: {
			type: [String, Number] as PropType<undefined | string | number>,
			default: null,
			required: false,
		},
		searchPlaceholder: {
			type: String,
			default: 'search.searchPlaceholder',
		},
		searchable: Boolean,
		unsorted: Boolean,
		closeOnSelection: Boolean,
		fullWidth: Boolean,
		showApplyButton: Boolean,
		showClearButton: Boolean,
		isActive: Boolean,
		disabled: Boolean,
	},
	setup(props, ctx) {
		const theUid = uid();
		const inputField = ref(null as null | Vue);
		const filterText = ref('');
		const isMenuOpen = ref(false);
		const filteredChoices = computed(() => props.choices
			.filter(({ label }) => label.toLocaleLowerCase().includes(filterText.value.toLocaleLowerCase()))
			.sort((a, b) => (props.unsorted ? 0 : a.label.localeCompare(b.label))));
		return {
			ButtonPalettes,
			uid: theUid,
			inputField,
			filterText,
			isMenuOpen,
			filteredChoices,
			onClose() {
				if (isMenuOpen.value) {
					isMenuOpen.value = false;
					filterText.value = '';
					ctx.emit('close');
				}
			},
			selectItem(choice: SelectBoxChoice) {
				ctx.emit('select', choice.key);
				isMenuOpen.value = props.closeOnSelection ? false : isMenuOpen.value;
			},
			toggleMenu: async () => {
				isMenuOpen.value = !isMenuOpen.value;
				if (!props.focusItemKey || !isMenuOpen.value) {
					return;
				}
				// 2 nextTicks because of Portal...
				await nextTick();
				await nextTick();
				const el = document.querySelector(`#${theUid} [data-key="${props.focusItemKey}"]`) as undefined | HTMLButtonElement;
				if (!el) {
					return;
				}
				el.focus();
				el.scrollIntoView({ block: 'center' });
			},
		};
	},
});
